import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import './SubscriptionModal.css'
import '../../../assets/css/modal.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
const SubscriptionModal = ({ showSubscriptionModal, setShowSubscriptionModal }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);

  function hideModalOperation() {
    setShowSubscriptionModal(false)
  }

  useEffect(() => {
    // let msisdn = null;

    // if (playerData?.id) {
    //   msisdn = playerData?.msisdn;
    // }
    // activityLogSubmission("contacts", msisdn);
    // analyticEvent('contact', 'contact-view')
  }, [])


  return (
    <>
      <Modal show={showSubscriptionModal} centered dialogClassName="modal-dialog" contentClassName="modalContent" onHide={hideModalOperation}>
        <Modal.Header closeButton>
          <Modal.Title>সাবস্ক্রিপশন</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <span className='modalSubsCustom'>  আপনি সফলভাবে সাবস্ক্রাইবড হয়েছেন। </span>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default SubscriptionModal